import { render } from "./DeviceItem.vue?vue&type=template&id=15c81456"
import script from "./DeviceItem.vue?vue&type=script&lang=js"
export * from "./DeviceItem.vue?vue&type=script&lang=js"

import "./DeviceItem.vue?vue&type=style&index=0&id=15c81456&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__